// test19
(19 && 0);
